import React from 'react';
import {ExplainButton} from "./buttons/explainbutton";
import {PracticeButton} from "./buttons/practicebutton";
import bubbles from "./mascot/bubble_left.svg";

/**
 * @author: Alisa Münsterberg
 * @date: 2022-10-14
 */

export default class StartPage extends React.Component {
	/*
	* Renders the start page with the mascot, a welcome message and an Explanation- and PracticeButton upon starting the app.
	*/
	render(){
		return (
				<div >
					<img src={bubbles}  className="Start-Mascot" alt={"Bubbles, das Maskottchen des Bubblesort-Tutors, eine blaue und lilane Seifenblase."}/>
					<div className = "App">
						<h2>
							Hallo, ich bin Bubbles! <br /> <br />
							Hast du Lust, mit mir zu lernen,<br />
							was der Bubblesort-Algorithmus kann? <br /> <br />
						</h2>
						<div className="App-buttons">
							<ExplainButton/>
							<PracticeButton/>
						</div>
					</div>
				</div> 
		  );
                
	}
}